const normalizeText = (value = '') =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');

const localizeKnownError = (error, t) => {
  const status = Number(error?.response?.status || 0);
  const rawMessage =
    error?.response?.data?.errorDescription ||
    error?.response?.data?.message ||
    error?.message ||
    '';
  const normalized = normalizeText(rawMessage);

  if (!normalized) {
    if (status === 403) return t('errors.accessDenied');
    if (status === 404) return t('errors.notFound');
    if (status >= 500) return t('errors.serverUnavailable');
    return '';
  }

  if (normalized.includes('tenantid does not match request host')) return t('errors.tenantHostMismatch');
  if (normalized.includes('network error')) return t('errors.network');
  if (normalized.includes('timeout') || error?.code === 'ECONNABORTED') return t('errors.timeout');
  if (
    normalized.includes('invalid credentials') ||
    normalized.includes('invalid username') ||
    normalized.includes('invalid password') ||
    normalized.includes('bad credentials')
  ) {
    return t('errors.invalidCredentials');
  }
  if (normalized.includes('otp') && (normalized.includes('expired') || normalized.includes('timeout'))) {
    return t('errors.otpExpired');
  }
  if (
    normalized.includes('otp') &&
    (normalized.includes('invalid') || normalized.includes('incorrect') || normalized.includes('mismatch'))
  ) {
    return t('errors.invalidOtp');
  }
  if (normalized.includes('mobile') && normalized.includes('not registered')) {
    return t('errors.mobileNotRegistered');
  }
  if (normalized === 'request failed') return t('errors.requestFailed');
  if (status === 403) return t('errors.accessDenied');
  if (status === 404) return t('errors.notFound');
  if (status >= 500) return t('errors.serverUnavailable');
  return '';
};

export const resolveApiErrorMessage = (error, t, fallback = '') => {
  const localized = localizeKnownError(error, t);
  if (localized) return localized;

  const rawMessage =
    error?.response?.data?.errorDescription ||
    error?.response?.data?.message ||
    error?.message ||
    '';

  return rawMessage || fallback || t('errors.requestFailed');
};

export default resolveApiErrorMessage;
